// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI, {
  Message
} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from './axios'
import App from './App'
import router from './router'
import qs from 'qs'
import global from './components/utils/Global.vue'
import 'ant-design-vue/dist/antd.css';
import AntDesignUI from 'ant-design-vue';
import {
  message
} from 'ant-design-vue';
import './assets/fonts/iconfont.css'
import Flexible from './public/flexible.js'
import resetSize from './public/resetsize.js'
import store from './store'
import service from './api/request.js'


Vue.prototype.$msg = message;
Vue.prototype.$resetSize = resetSize;
Vue.use(AntDesignUI);
Vue.use(ElementUI);
Vue.use(Flexible)

Vue.config.productionTip = false;

Vue.prototype.$axios = axios // 全局注册，使用方法为:this.$axios
Vue.prototype.$qs = qs // 全局注册，使用方法为:this.$qs
Vue.prototype.$vue = Vue
QHPass.init({
  src: "pcw_aimonitor",
  primaryColor: "#4B93FF",
  signIn: {
    types: ["normal", "mobile"],
    normal: {
      onlyMobile: true
    },
    "thirdPart": {
      "providers": []
    },
    hideKeepAlive: false,
  },
  "signUp": {
    "hidePasswordAgain": false
  }
});
router.beforeEach((to, from, next) => {
  if (to.name === "login") {
    return next()
  }
  if (global && global.userInfo) {
    if (to.name == 'ai' && to.query.platform == 'official') {
      requestAddUser(() => {
        router.push('/overview');
      });
    } else {
      if (to.query && to.query.to) {
        router.push(to.query.to);
      } else if (to.name == '/' || to.name == "" || to.name == "main") {
        router.push('/overview');
      }
      next();
    }
  } else {
    if (global && global.isJumpingToLogin) {
      next();
      return;
    }
    QHPass.getUserInfo(
      function (data) {
        if (global) {
          global.userInfo = data;
        }
        if (to.name == 'ai' && to.query.platform == 'official') {
          requestAddUser(() => {
            router.push('/overview');
          });
        } else {
          if (to.query && to.query.backto) {
            router.push(to.query.backto);
          } else if (to.name == '/' || to.name == "" || to.name == "main") {
            router.push('/overview');
          }
          next();
        }
      },
      function (err) {
        global.userInfo = null;
        global.isJumpingToLogin = true;
        var p_;
        if (to.fullPath == '' || to.fullPath == '/') {
          p_ = 'login?backto=overview';
        } else if (to.fullPath.indexOf("login?backto=") != -1) {
          p_ = to.fullPath;
        } else {
          p_ = "login?backto=" + to.fullPath;
        }
        router.push({
          path: p_
        });
        next();
        // if(window.location.host == 'monitor.zyun.360.cn')
        // {
        //     if(p_.slice(0, 1) == '/')
        //     {
        //         window.location.href = 'https://monitor.zyun.360.cn/#' + p_;
        //         return;
        //     }
        //     window.location.href = 'https://monitor.zyun.360.cn/#/' + p_;
        //     return;
        // }
        // else
        // {
        //     router.push({ path: p_ });
        //     next();
        // }
      }
    );
  }
});

function requestAddUser(callback) {
  var reqData = {
    qid: global.userInfo.qid,
    from_saas: 1,
  };
  var postData = md5(global.getKV(global.ksort(reqData)) + global.xiaoanKey);
  axios({
      method: 'post',
      baseURL: '/api',
      url: global.ajaxAdd.addUser,
      data: qs.stringify(reqData),
      headers: {
        'Authorization': postData
      }
    })
    .then(function (d) {
      if (d && d.status == 200 && d.data) {
        if (d.data.errno == 0) {
          if (callback) {
            callback();
          }
        } else if (d.data.errno == 500005) {
          window.location.href = 'https://zyun.360.cn/console/usercenter/qualification';
        } else {
          message.error(d.data.errmsg);
        }
      } else {
        message.error('查询用户状态返回异常1');
      }
    })
    .catch(function (e) {
      message.error('查询用户状态返回异常2');
    });
  return;
}

const showMessage = Symbol('showMessage')
/**
 *  重写ElementUI的Message
 *  single默认值true，因为项目需求，默认只弹出一个
 */
class DonMessage {
  success(options, single = true) {
    this[showMessage]('success', options, single)
  }
  warning(options, single = true) {
    this[showMessage]('warning', options, single)
  }
  info(options, single = true) {
    this[showMessage]('info', options, single)
  }
  error(options, single = true) {
    this[showMessage]('error', options, single)
  }

  [showMessage](type, options, single) {
    if (single) {
      // 判断是否已存在Message
      if (document.getElementsByClassName('el-message').length === 0) {
        Message[type](options)
      }
    } else {
      Message[type](options)
    }
  }
}
Vue.prototype.$_message = new DonMessage()

Vue.directive('loadmore', {
  bind(el, binding) {
    // 获取element-ui定义好的scroll盒子
    const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
    SELECTWRAP_DOM.addEventListener('scroll', function () {
      const CONDITION = this.scrollHeight - this.scrollTop <= this.clientHeight
      if (CONDITION) {
        binding.value()
      }
    })
  }
})
window.addEventListener('popstate', function () {
  if (this.document.URL.indexOf('/live') > -1) {
    history.pushState(null, null, document.URL)
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js